<template src="./Extrato.html"></template>

<script>

import mixins from "@/Mixins.js";

// https://www.npmjs.com/package/vue-button-spinner
import ButtonSpinner from "vue-button-spinner";

export default {
  mixins: [mixins],
  components: {
    ButtonSpinner,
  },
  data() {
    return {
      extracts:[],
      pagination: false,
      currentxExtract: 1,
      numPagesExtract: 0,
      paginationExtract: false,
      windowWidth: 0,
      idCompany: null,
      typeEnum: {
        CREDIT: "Crédito",
        DEBIT: "Débito",
        MOVEMENT: "Movimentação"
      },
      statusEnum: {
        AUTHORIZED: "Autorizado",
        UNAUTHORIZED: "Transação negada",
        PENDING: "Pendente",
        WAITING_PAYMENT: "Aguardando pagamento",
        EXPIRED: "Expirado",
        PAID: "Pago",
        CANCELED: "Cancelado",
        ERROR: "Error",
        Transaction_declined: "Transação recusada",
      },
    }
  },
  watch: {
    currentxExtract: function () {
      const vm = this;
      vm.changePagination();
    },
  },
  mounted() {
    const vm = this;
    vm.Iugu = document.createElement("script");
    vm.Iugu.setAttribute("src", "https://js.iugu.com/v2");
    document.head.appendChild(vm.Iugu);
    vm.init();
  },
  methods: {
    init() {
      console.log('tô aqui....')
      this.fetchPoolAccounts();
    },
    handleResize() {
      const vm = this;
      vm.windowWidth = window.innerWidth;
    },
    translateStatusTypes(data) {
      const vm = this;
      for (var item in data) {
        const indexOfStatus = Object.keys(vm.statusEnum).indexOf(data[item].status);
        data[item].statuses = Object.values(vm.statusEnum)[indexOfStatus];
        const indexOtype = Object.keys(vm.typeEnum).indexOf(data[item].type);
        data[item].types = Object.values(vm.typeEnum)[indexOtype];
      }
      return data
    },
    changePagination() {
      const vm = this;
      vm.$vs.loading();
      vm.fetchPoolAccounts();
    },
    changePaginationExtract() {
      const vm = this;
      const poolExtract = vm.extracts;
      if (vm.currentxExtract === 1) {
        vm.extractExtractPaginated = poolExtract.slice(0, 5);
      } else {
        vm.extractExtractPaginated = poolExtract.slice(
          (vm.currentxExtract - 1) * 5,
          vm.currentxExtract * 5
        );
      }
    },
    fetchPoolAccounts() {
      const vm = this;
      let page = 0;
      const size=10;
      if (vm.currentxExtract === 1) {
        page = 0;
      } else if (vm.currentxExtract > 1) {
        page = vm.currentxExtract - 1;
      }

      if (vm.testNullUndefinedEmpty(vm.$route.params.id) === false) {
        vm.idCompany = vm.$route.params.id;
        vm.axios
          .get(`${vm.$store.state.filooServer}pool-profile/extract/company/${vm.idCompany}?page=${page}&size=${size}` , {
            headers: { Authorization: vm.$session.get("bearer") },
          })
          .then(function(response) {
            vm.extracts = vm.translateStatusTypes(response.data.content);
            vm.numPagesExtract = response.data.totalPages;
            vm.paginationExtract= vm.numPagesExtract > 1;
            vm.changePaginationExtract();
          })
          .catch(function(error) {
            console.log({error: error});
          }).finally(() => vm.$vs.loading.close());
      }
    },
  },
}
</script>
